import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import { useHODLContract as n } from "../store/hodlContract.mjs";
import "../store/subgraph.mjs";
import { commonOwner as o } from "../util/common.mjs";
const w = o(n);
function d(t, r) {
  return n(t).balanceOf(r);
}
function h(t, r, e) {
  return n(t).allowance(r, e);
}
function l(t, r) {
  return n(t, !0).deposit(r);
}
function F(t, r) {
  return n(t, !0).withdraw(r);
}
function N(t, r, e) {
  return n(t, !0).approve(r, e);
}
async function T(t) {
  return await n(t).isCheckNFT();
}
async function C(t) {
  return await n(t).NFTAddress();
}
async function k(t, ...r) {
  return await n(t, !0).setIsCheckNFT(...r);
}
export {
  C as NFTAddress,
  h as allowance,
  N as approve,
  d as balanceOf,
  l as deposit,
  T as isCheckNFT,
  w as owner,
  k as setIsCheckNFT,
  F as withdraw
};
//# sourceMappingURL=hodl.mjs.map
